<template>
    <component :is="component" :updateItem="updateItem"></component>
</template>

<script>
import RomaFormNewLesson from "@/components/lesson/RomaFormNewLesson";
export default {
    data() {
        return {
            component: RomaFormNewLesson,
            updateMode: false,
            id: this.$route.params.id
        };
    },
    computed: {
        updateItem() {
            return this.$route.params.id ? this.$route.params.id : "";
        }
    }
};
</script>

<style></style>
